import { getView, requireAuth } from '@/lib/utils';
import {
  AssetMaterialPage,
  AssetMaterialFilesPage,
  AssetMaterialsPage,
} from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/asset/:keyParent/material-assign/:_key',
  name: 'assetMaterial',
  component: getView('pages/PageAssetMaterial'),
  redirect: { name: 'assetMaterial-details' },
  beforeEnter: requireAuth,
  meta: {
    roles: ['operator'],
  },
  children: [
    {
      path: 'details',
      name: 'assetMaterial-details',
      component: getView('assetMaterials/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Material > Details',
        leftMenu: Left.AssetMaterial,
        information: AssetMaterialPage,
        showBottomMenu: false,
      },
    },
    {
      path: 'heads',
      name: 'assetMaterial-heads',
      component: getView('assetMaterials/TabHeadsDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Material > Heads',
        leftMenu: Left.AssetMaterial,
        information: AssetMaterialPage,
        showBottomMenu: false,
      },
    },
    {
      path: 'files',
      name: 'assetMaterial-files',
      component: getView('assetMaterials/TabFiles'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Material > Files',
        leftMenu: Left.AssetMaterialFiles,
        information: AssetMaterialFilesPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'edit',
      name: 'assetMaterialEdit',
      component: getView('pages/PageAssetMaterialEdit'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Material > Edit',
        leftMenu: Left.AssetsList,
        information: AssetMaterialsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'create',
      name: 'assetMaterialCreate',
      component: getView('pages/PageAssetMaterialEdit'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Material > Create',
        leftMenu: Left.AssetsList,
        information: AssetMaterialsPage,
        showBottomMenu: true,
      },
    },
  ],
};
